import { Grid, Checkbox, FormGroup, FormControlLabel, FormHelperText } from '@mui/material';
import { red } from '@mui/material/colors';

export default function MuiCheckbox({
  sx = {},
  label,
  field,
  form: { touched, errors, values },
  name,
  ...props
}) {
  const hasError = touched[field.name] && errors[field.name] && true;
  const style = { color: hasError && red[500] };

  return (
    <FormGroup sx={sx}>
      <FormControlLabel
        control={
          <Checkbox name={name} {...field} {...props} sx={style} checked={values[field.name]} />
        }
        sx={style}
        label={label}
      />
      <Grid container sx={{ alignSelf: 'end' }}>
        <FormHelperText sx={{ m: 0 }} error={true}>
          {hasError && errors[field.name]}
        </FormHelperText>
      </Grid>
    </FormGroup>
  );
}
